import { Controller } from "stimulus"

import Rails from "@rails/ujs";

export default class extends Controller {
  fetch(event) {
    let leagueId = event.target.value;
    let type = event.target.dataset.type;
    if (leagueId) {
      const url = "/rounds/" + leagueId + "/next?type=" + type;
      const data = new FormData();
      data.append("league_id", leagueId);

      Rails.ajax({
        type: "GET",
        url: url,
        data: data
      });
    }
  }
}